import React from "react";
import Loadable from "react-loadable";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import MediaQuery from "react-responsive";

import { AsynLoader } from "../Loader/AsynLoader";
import Modal from "../Modals";
import { queryStringSort } from "../../actions";
import { generateQueryStringFromReduxState, queryString } from "../../utils";

class Sorting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sort: "",
      order: "desc",
      sortedBy: props.sortedBy || "",
      showModal: false,
      redirect: ""
    };
  }
  componentWillUnmount() {
    window.removeEventListener("mousedown", this.detectClickOutSide);
  }
  componentDidMount() {
    window.addEventListener("mousedown", this.detectClickOutSide);
    const { sort, order } = this.props.query.sort;
    this.setState({ sort, order });
    this.setSortedByText(sort, order);
  }

  componentDidUpdate(prevProps) {
    if (this.props.query.sort !== prevProps.query.sort) {
      const { sort, order } = this.props.query.sort;
      this.setState({ sort, order });
      this.setSortedByText(this.props.query.sort.sort, this.props.query.sort.order);
    }
  }
  setSortedByText = (sort, order) => {
    switch (sort) {
      case "popularity":
        this.setState({ sortedBy: "Popular" });
        break;
      case "price":
        if (order === "desc") {
          this.setState({ sortedBy: "Price: High to Low" });
        } else {
          this.setState({ sortedBy: "Price: Low to High" });
        }
        break;
      case "duration":
        if (order === "desc") {
          this.setState({ sortedBy: "Duration: Longest" });
        } else {
          this.setState({ sortedBy: "Duration: Shortest" });
        }
        break;
      case "created":
        this.setState({ sortedBy: "New Activities" });
        break;
      case "rating":
        this.setState({ sortedBy: "Rating", order: "desc" });
        break;
      default:
        this.setState({ sortedBy: "Popular", order: "desc" });
        break;
    }
  };

  handleSelect = (sort, order) => {
    this.setSortedByText(sort, order);

    let q = generateQueryStringFromReduxState(this.props.query);
    q.sort = sort;
    q.order = order;
    console.log(q);
    this.setState({
      sort,
      order,
      showModal: false,
      redirect: "/activity?" + queryString.stringify(q)
    });

    this.props.queryStringSort({ sort, order });
  };

  handleReset = () => {
    this.setSortedByText("popular", "desc");
    let q = generateQueryStringFromReduxState(this.props.query);
    q.sort = "popularity";
    q.order = "desc";
    this.setState({
      sort: "popularity",
      order: "desc",
      showModal: false,
      redirect: "/activity?" + queryString.stringify(q)
    });

    this.props.queryStringSort({ sort: q.sort, order: q.order });
  };
  detectClickOutSide = e => {
    if (window.innerWidth > 700)
      if (!this.sortingRef.contains(e.target)) {
        this.setState({ showModal: false });
      }
  };

  render() {
    return (
      <div className="t-container-fluid" ref={node => (this.sortingRef = node)}>
        {this.state.redirect !== "" && <Redirect to={this.state.redirect} />}
        <div
          className={`filter__buttons__tertiary selected`}
          onClick={() => this.setState(prev => ({ showModal: !prev.showModal }))}>
          <div
            style={{
              maxWidth: "100%",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}>
            <span className={this.state.order === "desc" ? "high-low-sorting" : "high-low-sorting low"} />
            {this.state.sortedBy}
          </div>
        </div>

        {this.state.showModal && (
          <MediaQuery maxWidth={700}>
            {matches => {
              if (matches) {
                return (
                  <Modal close={() => this.setState({ showModal: false })} reset={this.handleReset}>
                    <AsynSortingModal
                      handleSelect={this.handleSelect}
                      selected={this.state.sort}
                      order={this.state.order}
                    />
                  </Modal>
                );
              } else {
                return (
                  <ul className="dropdown__list">
                    <li className="item" onClick={() => this.handleSelect("popularity", "desc")}>
                      Popular
                    </li>
                    <li className="item" onClick={() => this.handleSelect("price", "desc")}>
                      Price: High to Low
                    </li>
                    <li className="item" onClick={() => this.handleSelect("price", "asc")}>
                      Price: Low to High
                    </li>
                    <li className="item" onClick={() => this.handleSelect("duration", "desc")}>
                      Duration: Longest
                    </li>
                    <li className="item" onClick={() => this.handleSelect("duration", "asc")}>
                      Duration: Shortest
                    </li>
                    <li className="item" onClick={() => this.handleSelect("created", "desc")}>
                      New Activities
                    </li>
                    <li className="item" onClick={() => this.handleSelect("rating", "desc")}>
                      Rating
                    </li>
                  </ul>
                );
              }
            }}
          </MediaQuery>
        )}
      </div>
    );
  }
}

const AsynSortingModal = Loadable({
  loader: () => import("../Modals/Sorting"),
  render(loaded, props) {
    let Component = loaded.default;
    return <Component {...props} />;
  },
  loading: AsynLoader,
  delay: 0
});

const mapStateToProps = state => {
  return {
    query: state.queryString
  };
};
const mapDispatchToProps = dispatch => {
  return {
    queryStringSort: sorting => dispatch(queryStringSort(sorting))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Sorting);
